import styled from 'styled-components'

export const Root = styled.div`
    display: flex;
    // flex-direction: column;
    gap: 8px;
`

export const HexRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
`

export const NameInputWrap = styled.div`
    min-width: 160px;
    flex: 1;
`

export const OptionRow = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`

export const OptionSwatch = styled.span<{ $hex: string }>`
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    background: ${props => props.$hex};
    flex-shrink: 0;
`

export const PantoneSelectWrap = styled.div`
    min-width: 220px;

    .ant-select {
        width: 100%;
    }
`
